import { Button, HStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { QueryPhrasesApi } from '../../apis/QueryMaintenance.api';
import { PhrasesSearchCondition } from '../../pages/PhrasesMaintenance';
import { CategorySendMessageType } from '../constants/MaintenanceConstants';
import { MaintenanceCompareEnum } from '../constants/MaintenanceConstants';
import { PhrasesType } from '../organisms/Maintenance/Table/MaintenancePhrasesTable';

interface props {
  Query: PhrasesSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<PhrasesSearchCondition>>;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<PhrasesType[] | undefined>
  >;
  createOrUpdate: boolean;
  chooseButton: string;
  MessageTypeChange: (type: string) => void;
}

const PhrasesChangeTypeButtons: React.FC<props> = (props) => {
  const {
    Query,
    setQuery,
    setMaintenanceDatas,
    createOrUpdate,
    chooseButton,
    MessageTypeChange
  } = props;

  useEffect(() => {
    MessageTypeChange(CategorySendMessageType.None);
  }, [MessageTypeChange, createOrUpdate]);

  const SerachGetApi = async (messageType: string) => {
    const params = new URLSearchParams();
    if (Query.count.countData !== '') {
      switch (Query.count.compare) {
        case MaintenanceCompareEnum.Equal:
          params.append('count_eq', Query.count.countData);
          break;
        case MaintenanceCompareEnum.Greater:
          params.append('count_gt', Query.count.countData);
          break;
        case MaintenanceCompareEnum.Less:
          params.append('count_lt', Query.count.countData);
          break;
      }
    }
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    Query.category !== '' && params.append('category_id_eq', Query.category);
    Query.phrases !== '' && params.append('body_contains', Query.phrases);
    messageType !== CategorySendMessageType.None &&
      params.append('type', messageType);
    Query.dateCreatedFrom !== '' &&
      params.append('created_at_gte', Query.dateCreatedFrom);
    Query.dateCreatedTo !== '' &&
      params.append('created_at_lt', Query.dateCreatedTo);
    Query.dateUpdatedFrom !== '' &&
      params.append('updated_at_gte', Query.dateUpdatedFrom);
    Query.dateUpdatedTo !== '' &&
      params.append('updated_at_lt', Query.dateUpdatedTo);

    const apiQuery = '/?' + params.toString();
    setQuery((pre) => ({ ...pre, type: messageType }));
    const response = await QueryPhrasesApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as PhrasesType[]);
    }
  };
  return (
    <HStack ml={5} mt={4}>
      <Button
        _hover={{ bgColor: '' }}
        _focus={{ bgColor: '' }}
        bgColor={
          chooseButton === CategorySendMessageType.None
            ? 'blackAlpha.600'
            : 'silver'
        }
        fontSize='12'
        onClick={() => {
          MessageTypeChange(CategorySendMessageType.None);
          SerachGetApi(CategorySendMessageType.None);
        }}
      >
        すべて
      </Button>
      <Button
        _hover={{ bgColor: '' }}
        _focus={{ bgColor: '' }}
        bgColor={
          chooseButton === CategorySendMessageType.Message
            ? 'blackAlpha.600'
            : 'silver'
        }
        fontSize='12'
        onClick={() => {
          MessageTypeChange(CategorySendMessageType.Message);
          SerachGetApi(CategorySendMessageType.Message);
        }}
      >
        共通メッセージ用
      </Button>
      <Button
        _hover={{ bgColor: '' }}
        _focus={{ bgColor: '' }}
        bgColor={
          chooseButton === CategorySendMessageType.Obc
            ? 'blackAlpha.600'
            : 'silver'
        }
        fontSize='12'
        onClick={() => {
          MessageTypeChange(CategorySendMessageType.Obc);
          SerachGetApi(CategorySendMessageType.Obc);
        }}
      >
        OBCメッセージ用
      </Button>
      <Button
        _hover={{ bgColor: '' }}
        _focus={{ bgColor: '' }}
        bgColor={
          chooseButton === CategorySendMessageType.Signage
            ? 'blackAlpha.600'
            : 'silver'
        }
        fontSize='12'
        onClick={() => {
          MessageTypeChange(CategorySendMessageType.Signage);
          SerachGetApi(CategorySendMessageType.Signage);
        }}
      >
        停留場メッセージ用
      </Button>
      <Button
        _hover={{ bgColor: '' }}
        _focus={{ bgColor: '' }}
        bgColor={
          chooseButton === CategorySendMessageType.Location
            ? 'blackAlpha.600'
            : 'silver'
        }
        fontSize='12'
        onClick={() => {
          MessageTypeChange(CategorySendMessageType.Location);
          SerachGetApi(CategorySendMessageType.Location);
        }}
      >
        位置情報メッセージ用
      </Button>
    </HStack>
  );
};
export default React.memo(PhrasesChangeTypeButtons);
